import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import { OutGoingTab } from "./OutGoingTab";

export default function AppointmentsRequestsCandidate() {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  const tabs = [{ name: t("outgoing"), content: <OutGoingTab /> }];
  return (
    <div className="w-full flex flex-col bg-gray-50 ">
      <div>
        <h1 className=" text-2xl font-semibold px-8 text-gray-900 mt-2 mb-4">
          {t("changeAppointments")}
        </h1>
      </div>
      <TabsComponent requests={true} tabs={tabs} />
    </div>
  );
}
